import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './InternalPageContent.module.css';
export const InternalPageContent = ({ children, title, action }) => {
    return (_jsxs("div", { className: `${styles.container}`, "data-testid": 'internal-page-content', children: [_jsx("h1", { className: styles.title, "data-testid": 'internal-page-content-title', children: title }), action && (_jsx("div", { className: styles.action, "data-testid": 'internal-page-content-action', children: action })), _jsx("main", { className: styles.content, "data-testid": 'internal-page-content-content', children: children })] }));
};
export default InternalPageContent;
